import React from 'react'
import Button from '../../../components/button/Button';

const HeroSection = () => {
    return (
        <div className="max-lg:flex-col relative min-h-[800px] heroBack flex items-center justify-between py-[64px] pb-[96px] max-lg:gap-[32px] w-full">
            <div className="flex flex-col max-lg:items-center items-start gap-[48px] lg:pl-[5.8vw] px-[5.8vw] max-sm:gap-[24px]">
                <div className="flex flex-col items-start gap-[24px] max-lg:items-center max-sm:gap-[16px]">

                    {/* Announcement Banner */}
                    <div className="max-sm:hidden flex items-center justify-center rounded-full p-[4px] bg-[#F9F5FF] border-[1px] border-[#E9D7FE] gap-[10px] pr-[10px] group">
                        <span className='text-[14px] text-[#6941C6] px-[10px] py-[2px] rounded-full border-[1px] border-[#E9D7FE]'>
                            We’re Launching our mobile app!
                        </span>
                        <div className="flex items-center gap-[4px] transition-all group-hover:gap-[10px]">
                            <span className='text-[14px] text-[#6941C6]'>
                                We’re Launching our mobile app!
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className='transition-all'>
                                <path d="M3.33334 8.00004H12.6667M12.6667 8.00004L8 3.33337M12.6667 8.00004L8 12.6667" stroke="#9E77ED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>

                    {/* Headline */}
                    <h1 className='font-bold text-[#101828] max-w-[584px] max-2xl:text-[48px] max-xl:text-[42px] max-lg:text-center text-[60px] md:text-[48px] max-sm:text-[36px]'>
                        Harness the power of positivity better every day
                    </h1>

                    {/* Description */}
                    <p className='text-[20px] text-[#475467] max-w-[480px]'>
                        Join our program today and let's transform your body and mind together. No more excuses just focus, work well with dedication. Are you up for the challenge?
                    </p>

                </div>

                {/* Buttons */}
                <div className="flex items-center gap-[12px] max-sm:flex-col max-sm:w-full">
                    <a target='_blank' href='https://docs.google.com/forms/d/e/1FAIpQLSebWsb4zsd9oMmlb6NldbYOgEk0KXRKZ2fVbkdJVMxWjt6mig/viewform?usp=sf_link' rel="noreferrer" className='border-[1px] border-[#D0D5DD] max-sm:w-full font-[500] text-center text-[18px] py-[16px] px-[24px] rounded-[8px] cursor-pointer'>
                        Health Survey
                    </a>

                    <Button children={'Book Appointment'} className={'max-sm:w-full text-center'} />
                </div>
            </div>
            <img
                src="/images/heroImage.png"
                alt=""
                className='heroImage max-w-[760px] max-2xl:max-w-[660px] max-xl:max-w-[560px] max-sm:max-w-full'
            />
        </div>

    )
}

export default HeroSection;